<div class="dialog-title">
  Colour Chooser
  <button mat-dialog-close mat-icon-button class="close-button"
    [attr.aria-label]="'scheduler.general.close' | translate" [attr.title]="'scheduler.general.close' | translate">
    <mat-icon fontIcon="fa-window-close" fontSet="fas"></mat-icon>
    <span class="visually-hidden">{{ 'scheduler.general.close' | translate }}</span>
  </button>
</div>

<mat-dialog-content>
  <div class="preview-section" [style.background-color]="backgroundColor" [style.color]="foregroundColor">
    Preview
  </div>

  <form [formGroup]="chooserForm" class="color-form">
    <div class="input-group">
      <label id="fillColorLabel">Fill Colour</label>
      <input [(colorPicker)]="backgroundColor" (colorPickerChange)="colourChanged()"
        [style.background]="backgroundColor" cpPosition="top" aria-labelledby="fillColorLabel"
        [attr.title]="'scheduler.setup.color-chooser.fill' | translate" />
    </div>

    <div class="input-group">
      <label id="borderColorLabel">Border Colour</label>
      <input [(colorPicker)]="foregroundColor" (colorPickerChange)="colourChanged()"
        [style.background]="foregroundColor" cpPosition="top" aria-labelledby="borderColorLabel"
        [attr.title]="'scheduler.setup.color-chooser.border' | translate" />
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="primary" [disabled]="chooserForm.pristine" (click)="save()">
    Save
  </button>
</mat-dialog-actions>